import { TextField } from "@shopify/polaris";
import styles from "../AddProductsUsingFiltersModal.module.css";
import { FieldRenderProps } from "react-final-form";
import { FC } from "react";

interface SelectedProductsFieldProps extends FieldRenderProps<any> {
}

const NumberField: FC<SelectedProductsFieldProps> = ({ input, label, prefix, text, disabled }) => {
  return (
    <div className={styles.numberFieldWrapper}>
      <span>{text}</span>
      <div>
        <TextField
          value={input.value}
          onChange={input.onChange}
          label={label}
          autoComplete="off"
          prefix={prefix}
          disabled={disabled}
          placeholder="0"
        />
      </div>
    </div>
  );
};

export default NumberField;